import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

import { textStyles } from '@/const/text-styles'

// Custom text-style utilities (e.g. `text-body-small`, `text-heading-large`) are size+weight+lineheight
// bundles, not colors. Teach tailwind-merge to treat them as `font-size` so they don't clash with
// `text-<color>` classes like `text-main-foreground-danger`.
const textStyleSuffixes = Object.keys(textStyles).map((selector) => selector.replace('.text-', ''))

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: textStyleSuffixes }],
    },
  },
})

export const cn = (...inputs: ClassValue[]): string => {
  return twMerge(clsx(inputs))
}
